import type { TrailPoint } from '../types/LiveMap.types';
import type { TimelineReport } from '../../routineTimeline/types/RoutineTimeline.types';
import type { Optional } from 'lib/types/Optional';

/**
 * When the route the robot is on started: the end of the route before it, or else the time the live map saw the route
 * change, until that route's report arrives. Null on the first route or without either.
 */
export const getCurrentRouteStartTime = (
  reports: TimelineReport[],
  step: Optional<number>,
  routeChangedAt: Optional<string>
): Optional<string> => {
  if (step == null || step <= 1) {
    return null;
  }

  const previousRouteEndTime = reports.find(report => report.routeIndex === step - 1)?.endTime;

  return previousRouteEndTime ?? routeChangedAt ?? null;
};

/** The trail from `since` on; the location history covers the whole run, earlier routes included. */
export const getTrailSince = (trail: TrailPoint[], since: Optional<string>): TrailPoint[] => {
  const sinceMs = since ? Date.parse(since) : NaN;

  if (Number.isNaN(sinceMs)) {
    return trail;
  }

  return trail.filter(point => Date.parse(point.updatedAt) >= sinceMs);
};
